import { render, staticRenderFns } from "./PartIndex.vue?vue&type=template&id=5df5553d"
import script from "./PartIndex.vue?vue&type=script&lang=ts"
export * from "./PartIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports